import configureStore from './configureStore';
import initialReduxState from './initialState';

const store = configureStore(initialReduxState);

export default store;
